import type { CotacaoCardProps } from "./types-cotacao-card";
import { useCotacaoCard } from "./use-cotacao-card";
import { CotacaoCardView } from "./view-cotacao-card";

export function CotacaoCard(props: CotacaoCardProps) {
  const vm = useCotacaoCard(props);

  return <CotacaoCardView {...vm} />;
}

export type * from "./types-cotacao-card";
